import { isAuthorizationRoute } from "./is-authorization-route";
export function isSmsTriggeringRoute(options) {
    return (["PATCH", "PUT", "POST"].includes(options.method) &&
        isAuthorizationRoute(options.url));
}
